import dateDiff from 'ha/helpers/hadate/diff';

interface AnalitycsProps {
  platformUserID: number;
  tenant_id?: number;
  conversation_id?: number;
}

interface PaymentRequest extends AnalitycsProps {
  handle: string;
  dueDate?: string;
}

const todayISO = () => {
  const date = new Date();
  date.setHours(0, 0, 0, 0); // start of day

  return date.toISOString();
};

const basePayload = (pr: AnalitycsProps) => ({
  advertiser_id: pr.platformUserID,
  is_anonymous: !pr.tenant_id,
  tenant_id: pr.tenant_id,
  conversation_id: pr.conversation_id,
});

const withID = (pr: PaymentRequest) => ({
  payment_request_id: pr.handle,
  ...basePayload(pr),
});

const withIDAndDueDate = ({ dueDate, ...rest }: PaymentRequest) => ({
  ...withID(rest),
  ...(dueDate && { due_date: dateDiff('days', todayISO(), dueDate) }),
});

export const analytics = {
  // creation flow
  formLoaded: (creationProps: AnalitycsProps) => ({
    type: 'Payment Request Creation Form Loaded',
    payload: basePayload(creationProps),
  }),
  created: (pr: PaymentRequest) => ({
    type: 'Payment Request Created',
    payload: withID(pr),
  }),
  // payment flow
  loaded: (pr: PaymentRequest) => ({
    type: 'Payment Request Loaded',
    payload: withID(pr),
  }),
  paid: (pr: PaymentRequest) => ({
    type: 'Payment Request Paid',
    payload: withIDAndDueDate(pr),
  }),
};
